import { axios, axios2 } from '@/lib/axios';
import { UploadResponse } from '@/types/UploadResponse';

export type UploadDTO = {
  file: File;
};

export const uploadThumbnail = (image: string): Promise<UploadResponse> => {
  return axios2.post('customer-api/upload-base64-image', { image });
};
